import { z } from 'zod';

export const omniIntegrationItem = z.object({
  id: z.string(),
  name: z.string(),
  companyId: z.number(),
  externalAccountId: z.string(),
  externalAccountName: z.string(),
  currency: z.string(),
  platform: z.string(),
  expired: z.boolean(),
  usingInCampaigns: z.boolean(),
  amazonRegion: z.string().nullable(),
  userUpdatedAt: z.string().nullable().optional(),
  connectedAt: z.string().optional(),
  connectedByUserId: z.string().optional(),
  connectedBy: z.string().optional(),
  userUpdatedId: z.string().or(z.number()).nullable().optional(),
});

const ValidationErrorSchema = z.object({
  location: z.array(z.union([z.string(), z.number()])),
  message: z.string(),
  errorType: z.string(),
});

export const ErrorResponse = z
  .object({
    type: z.string(),
    message: z.string(),
    code: z.number(),
    validationErrors: z.array(ValidationErrorSchema).nullable().optional(),
  })
  .nullable();
